<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>审批规则管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-tabs v-model="activeName">
        <el-tab-pane label="服务" name="1"></el-tab-pane>
        <!-- <el-tab-pane label="工业" name="2"></el-tab-pane> -->
        <!-- <el-tab-pane label="科学" name="3"></el-tab-pane> -->
      </el-tabs>
      <div class="panel pd-0 mb-20" v-for="item in stages" :key="item.id">
        <div class="rule-container">
          <div class="name">{{ item.name }}</div>
          <div style="width: 100%">
            <flow-table
              :category="1"
              :roles="roles"
              :dealerRank="item.id"
              :departmentId="parseInt(activeName)"
            ></flow-table>
            <flow-table
              :category="2"
              :roles="roles"
              :dealerRank="item.id"
              :departmentId="parseInt(activeName)"
            ></flow-table>
            <flow-table
              :category="3"
              :roles="roles"
              :dealerRank="item.id"
              :departmentId="parseInt(activeName)"
            ></flow-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlowTable from './flow_table'
import { roleList, dealerStageDiscountList } from '@/service/getData'

export default {
  components: {
    FlowTable,
  },
  data() {
    return {
      activeName: '1',
      roles: [],
      stages: [],
    }
  },
  created() {
    this.getRoles()
    this.getCustomerStages()
  },
  methods: {
    async getCustomerStages() {
      let res = await dealerStageDiscountList()
      if (res.code == 0) {
        this.stages = res.data.list
      }
    },
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.filter((item) => item.name != '超级管理员')
        this.roles.unshift({ id: 0, name: '请选择' })
      }
    },
  },
}
</script>

<style scoped>
.rule-container {
  display: flex;
  align-items: center;
  background: #2196f3;
  border: 1px solid #ebeef5;
  border-bottom: none;
  border-right: none;
}
.rule-container .name {
  width: 140px;
  min-width: 140px;
  text-align: center;
  color: #fff;
}
</style>
